import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';
import classnames from 'classnames';

type SectionWidthType = 'sm' | 'md' | 'lg';

interface SectionProps {
  hasBackground?: boolean;
  hasBorder?: boolean;
  hasPaddingTop?: boolean;
  hasPaddingBottom?: boolean;
  className?: string;
  children?: React.ReactNode;
  width?: SectionWidthType;
  blok?: SbBlokData;
}

const wrapperClassNames = ({
  hasBackground = false,
  hasBorder,
  className = '',
  width,
  hasPaddingTop,
  hasPaddingBottom
}: Partial<SectionProps>): string =>
  classnames(
    {
      'sb-section-sm': width === 'sm',
      'sb-section-md': width === 'md',
      'sb-section-lg': width === 'lg',
      'bg-black-20': hasBackground,
      'sb-section-has-border-bottom': hasBorder,
      'pb-4': !hasPaddingBottom && !className.includes('py-0'),
      'pt-4': !hasPaddingTop && !className.includes('py-0'),
      'sm:pb-8 md:pb-8': hasPaddingBottom,
      'sm:pt-4 md:pt-4': hasPaddingTop
    },
    className,
    'sb-section'
  );

export const Section: FunctionComponent<React.PropsWithChildren<SectionProps>> = ({
  hasBackground = false,
  hasBorder = false,
  className,
  width = 'md',
  blok,
  hasPaddingTop = false,
  hasPaddingBottom = false,
  children
}) => (
  <div
    className={wrapperClassNames({
      width,
      hasBackground,
      hasBorder,
      className,
      hasPaddingTop,
      hasPaddingBottom
    })}
  >
    {blok ? (
      <div {...storyblokEditable(blok)} className="sb-section-content">
        {children}
      </div>
    ) : (
      <div className="sb-section-content">{children}</div>
    )}
  </div>
);
